// namespace (소문자)
export const NAMESPACE = 'safeNumber';
//actions
export const GET_SAFE_NUMBER = 'GET_SAFE_NUMBER';
export const USE_SAFE_NUMBER = 'USE_SAFE_NUMBER';

//mutations
export const SET_SAFE_NUMBER = 'SET_SAFE_NUMBER';

// //state

// //getters
export const SAFE_NUMBER = 'SAFE_NUMBER';
